import { Injectable, inject } from '@angular/core';
import { PropertyModelRequest } from '@clubhub/ignite/models/property';
import { ProductsBtlModelRequest, ProductsResidentialModelRequest } from '@shared/models';
import { LendingTypeService } from '@shared/services';
import { Observable } from 'rxjs';
import { finalize, tap } from 'rxjs/operators';
import { CriteriaV2Service } from '../criteria/criteria-v2.service';

@Injectable({
  providedIn: 'root',
})
export class ProductsIntuitiveOutcomeService {
  private readonly lendingTypeService = inject(LendingTypeService);
  private readonly criteriaV2Service = inject(CriteriaV2Service);

  public criteriaLoadingInProgress: boolean = false;
  public criteriaSearchId: string | null = null;

  public getIntuitiveOutcome(
    productsModelRequest: ProductsResidentialModelRequest | ProductsBtlModelRequest,
    propertyModelRequest?: PropertyModelRequest | null,
  ): Observable<any> {
    return this.getProductsIntuitiveOutcomesV2(productsModelRequest, propertyModelRequest);
  }

  private get lendingTypeId() {
    return this.lendingTypeService.lendingType?.id ?? -1;
  }

  private getProductsIntuitiveOutcomesV2(productsModelRequest: any, propertyModelRequest?: PropertyModelRequest | null): Observable<any> {
    this.criteriaLoadingInProgress = true;
    return this.criteriaV2Service.getProductsIntuitiveOutcome(this.lendingTypeId, productsModelRequest, propertyModelRequest).pipe(
      tap(criteriaOutcomes => {
        this.criteriaSearchId = criteriaOutcomes.criteriaSearchId;
      }),
      finalize(() => {
        this.criteriaLoadingInProgress = false;
      }),
    );
  }
}
